import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn } from '@angular/common/http';
import { Observable, catchError, flatMap, from, map, mergeMap, of, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

/**
 * We need this because auth0 drops public requests if not authenticatd
 */
export function authInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    const authService = inject(AuthService);

    let accessToken = localStorage.getItem("access_token");
    let refreshToken = localStorage.getItem("refresh_token") || "";

    let requestToHandle: Observable<HttpEvent<any>>;

    if (accessToken && request.url.includes(environment.baseUrl)) {
        if (authService.hasTokenExpired(accessToken) && !request.url.includes("/api/public/user-profile/token")) {
            console.log(`Expired token on ${request.url}. Refreshing...`);
            return from(authService.refreshTokens(true)).pipe(
                switchMap(tokens => {
                    console.log(`Token refreshed: ${request.url}`);
                    accessToken = tokens.accessToken;
                    refreshToken = tokens.refreshToken;
                    const authRequest = addTokenToRequest(request, accessToken, refreshToken);
                    return next(authRequest).pipe(
                        catchError(error => {
                            if (request.url.includes(environment.baseUrl) && (error.status === 401 || error.status === 403)) {
                                authService.logout();
                            }
                            return throwError(() => error);
                        })
                    )
                })
            );
        }
        else {
            const authRequest = addTokenToRequest(request, accessToken, refreshToken);
            return next(authRequest).pipe(
                catchError(error => {
                    if (request.url.includes(environment.baseUrl) && (error.status === 401 || error.status === 403)) {
                        authService.logout();
                    }
                    return throwError(() => error);
                })
            );
        }
    }
    else {
        return next(request);
    }
}

function addTokenToRequest(request: HttpRequest<any>, accessToken: string, refreshToken: string) {
    return request.clone({
        setHeaders: {
            Authorization: `Bearer ${accessToken}`,
            ["X-Refresh-Token"]: refreshToken
        }
    });
}
